import { combineReducers } from 'redux';
import {authReducer} from './authReducer';
import {globalReducer} from './globalReducer';
import {productReducer} from './productReducer';
import {userReducer} from './userReducer';
import {cartReducer} from './cartReducer';
import {dashboardReducer} from './dashboardReducer';
import { expressReducer } from './expressReducer';
import { notificationReducer } from './notificationReducer';
import { promotionCampaignReducer } from './promotionCampaignReducer';
import {productSlice} from '../slices/Productslice';
const rootReducer = combineReducers({
    authReducer,
    globalReducer,
    productReducer,
    userReducer,
    cartReducer,
    dashboardReducer,
    expressReducer,
    notificationReducer,
    promotionCampaignReducer,
	productSlice
});
 export default rootReducer;